import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "@mui/material";
import AddProcedureModal from "./AddProcedureModal";
import ConsultationModal from "./ConsultationModal";
import InstructionModal from "./InstructionModal";
import "./modal.scss";
import ProcedureDelete from "./ProcedureDelete";
import TimeRangeModal from "./TimeRangeModal";
import InclinicRegularSuccess from "./InclinicRegularSuccess";
import InclinicFollowUpSuccess from "./InclinicFollowUpSuccess";
import TeleConsultRegularSuccess from "./TeleConsultRegularSuccess";
import TeleConsultFollowUpSuccess from "./TeleConsultFollowUpSuccess";
import ErrorModal from "./ErrorModal";
import DeleteModal from "./DeleteModal";
import ProcedureModal from "./ProcedureModal";

const MyScheduleModal = ({
  show,
  name,
  okayClickHandler,
  pendingappointments,
  procedureName,
  deleteprocedure,
  title,
  subtitle,
  errorModalClassName,
}) => {
  const renderSwitch = (param) => {
    switch (param) {
      case "addProcedureModal":
        return <AddProcedureModal okayClickHandler={okayClickHandler} />;
      case "timeRangeModal":
        return (
          <TimeRangeModal
            okayClickHandler={okayClickHandler}
            title={title}
            procedure={procedureName}
          />
        );
      case "deleteProcedureModal":
        return (
          <ProcedureDelete
            okayClickHandler={okayClickHandler}
            pendingappointments={pendingappointments}
            procedureName={procedureName}
            deleteprocedure={deleteprocedure}
          />
        );

      case "consultationModal":
        return <ConsultationModal okayClickHandler={okayClickHandler} />;
      case "instructionModal":
        return <InstructionModal okayClickHandler={okayClickHandler} />;
      case "inClinicRegular":
        return (
          <InclinicRegularSuccess
            okayClickHandler={okayClickHandler}
            title={title}
            procedure={procedureName}
          />
        );
      case "inClinicFollowUp":
        return (
          <InclinicFollowUpSuccess
            okayClickHandler={okayClickHandler}
            title={title}
            procedure={procedureName}
          />
        );
      case "teleConsultRegular":
        return (
          <TeleConsultRegularSuccess
            okayClickHandler={okayClickHandler}
            title={title}
            procedure={procedureName}
          />
        );
      case "teleConsultFollowUp":
        return (
          <TeleConsultFollowUpSuccess
            okayClickHandler={okayClickHandler}
            title={title}
            procedure={procedureName}
          />
        );
      case "ErrorModal":
        return (
          <ErrorModal
            okayClickHandler={okayClickHandler}
            title={title}
            subtitle={subtitle}
            procedure={procedureName}
          />
        );
      case "DeleteModal":
        return (
          <DeleteModal
            okayClickHandler={okayClickHandler}
            title={title}
            subtitle={subtitle}
            procedure={procedureName}
          />
        );
      case "procedureModal":
        return <ProcedureModal okayClickHandler={okayClickHandler} />;
      default:
        return null;
    }
  };
  return (
    <Fragment>
      {show ? (
        <Modal open={show} >
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className={`${errorModalClassName} consultation-modal-wrapper py-4 px-2`}>
            {renderSwitch(name)}
            {/* {name === "AddProcedureModal" ? (
              <AddProcedureModal okayClickHandler={okayClickHandler} />
            ) : (
              <TimeRangeModal okayClickHandler={okayClickHandler} />
            )} */}
          </div>
        </div>
        </Modal>
      ) : null}
    </Fragment>
  );
};

export default MyScheduleModal;
